import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../hooks';

import Layout from './Layout';

// Same auth guard as the existing ProtectedRoute (token required, redirect to
// `/` if missing) but wraps the children in the v3 Layout instead of
// AuthenticatedLayout.  Routing into v3 surfaces means you opt-in to the new
// chrome; legacy routes keep using the old layout.

interface Props {
  children: ReactNode | ReactNode[];
  adminRequired?: boolean;
  // For HR-only surfaces (recruitment). Mirrors HR_PRIVILEGED_ROLES on
  // the API so the UI and the endpoint agree on who may see them.
  hrPrivilegedRequired?: boolean;
}

const ProtectedRouteV3 = ({
  children,
  adminRequired = false,
  hrPrivilegedRequired = false
}: Props) => {
  const { token, isAdmin, isHrPrivileged } = useAuth();

  if (!token) {
    return <Navigate to="/" replace />;
  }
  if (adminRequired && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  if (hrPrivilegedRequired && !isHrPrivileged) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRouteV3;
